__turbopack_context__.v({
  "activeContent": "_73YriG_activeContent",
  "list": "_73YriG_list",
  "sidebar": "_73YriG_sidebar",
  "subMenu": "_73YriG_subMenu",
  "viewport": "_73YriG_viewport",
  "wrapper": "_73YriG_wrapper",
});
